export const ACCOUNT_TYPE = {
  fractionalPro: 'fractionalPro',
  company: "company",
}

export const MINIMUM_TOKEN_DEDUCTION = 5;